module.exports = __webpack_public_path__ + "static/img/yyzz.84897bd1.png";